import React from "react";
import { DropdownBrowser } from "@reusejs/react";
import { useRouter } from "next/router";
import Link from "next/link";
import AuthButtons from "./AuthButtons";

const items = [
  { label: "Home", href: "/", active: false },
  {
    label: "Properties",
    href: "#",
    active: false,
    children: [
      {
        name: "Residential Assets",
        label: "Residential Assets",
        value: "residential",
        href: "/residential-auction-properties",
      },
      {
        name: "Commercial Assets",
        label: "Commercial Assets",
        value: "commercial",
        href: "/commercial-auction-properties",
      },
      {
        name: "Movable Assets",
        label: "Movable Assets",
        value: "industrial",
        href: "/industrial-auction-properties",
      },
    ],
  },
  // {
  //   label: "Services",
  //   href: "#",
  //   active: true,
  //   children: [
  //     {
  //       label: "Expert Consultation",
  //       href: "/services#expert-consulting",
  //       active: false,
  //     },
  //     {
  //       label: "Financing Assistance",
  //       href: "/services#financing-assistance",
  //       active: true,
  //     },
  //     {
  //       label: "Dedicated Relationship Manager",
  //       href: "/services#dedicated-relationship-manager",
  //       active: false,
  //     },
  //   ],
  // },
  // {
  //   label: "Subscription",
  //   href: "/subscription",
  //   active: false,
  // },
  { label: "Blogs", href: "/blogs", active: false },
  { label: "Contact", href: "/contactus", active: false },
  {
    label: "Shortlisted Assets",
    href: "/dashboard/shortlisted",
    active: false,
  },
  {
    label: "Enquired Assets",
    href: "/dashboard/enquired-assets",
    active: false,
  },
  {
    label: "Profile",
    href: "/dashboard/profile",
    active: false,
  },
  {
    label: "Bidding",
    href: process.env.NEXT_PUBLIC_BIDDER_URL,
    active: false,
  },
];

export default function NavButtons(props: any) {
  const router = useRouter();
  return (
    <>
      {props.sidebar === true && (
        <div className="block lg:hidden h-full bg-red-50 absolute top-16 z-40 w-full">
          <div className="relative bg-white border-b shadow-sm rounded-md">
            <DropdownBrowser
              dropdownBrowserClasses={{
                containerClasses:
                  "border-t dark:border-gray-800 bg-white dark:bg-gray-900 focus:outline-none rounded-md",
              }}
              items={items}
              onClick={(item) => {
                if (item.href !== "#") {
                  router.push(item.href);
                }
              }}
            />
            <div className="hidden">
              <Link href="/auction-properties">properties</Link>
              <Link href="/services">services</Link>
              <Link href="/contactus">contacts</Link>
            </div>
            <div className="flex justify-center py-3 border-t">
              <AuthButtons getStartActive={true} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
